import { svg } from 'lit';
import { PointLabelCollisionManager } from '../point-label/PointLabelCollisionManager.js';
export function DebugPointLabelCollision(pointLabelCollisionManager: PointLabelCollisionManager) {
  return svg`
    <g transform="translate(0, 0)" fill="none" class="point-label-collision-rects">
      ${pointLabelCollisionManager.collisonRects.map(rect => {
    return svg`
          <rect
            width=${rect.width}
            height=${rect.height}
            x=${rect.left}
            y=${rect.top}
            stroke="black"
            stroke-width="1"
          >
          </rect>
        `;
  })}
    </g>
  `;
}